<template>
  <a class="m-skip-to-content" :href="href">
    {{ t('MSkipToContent.skip_to_main_content', 'Skip to main content') }}
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import gb from './locales/en-GB.json'
import us from './locales/en-US.json'
import sv from './locales/sv.json'

export default defineComponent({
  name: 'MSkipToContent',
  i18n: {
    messages: {
      'en-GB': gb,
      'en-US': us,
      sv: sv,
    },
  },
  props: {
    href: {
      type: String,
      default: '#app-content',
    },
  },
  setup() {
    const { t } = useI18n()
    return { t }
  },
})
</script>

<style lang="scss" scoped>
.m-skip-to-content {
  // Presentation style
  background: var(--skin-background-dark);
  border: 0;
  // Hide visually in an accessible way
  clip: rect(0 0 0 0);
  clip-path: polygon(0px 0px, 0px 0px, 0px 0px);
  color: var(--skin-color-dark);
  height: auto;
  left: 0px;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  text-align: center;
  top: -40px;
  white-space: nowrap;
  width: 1px;

  &:focus-visible {
    // Override visually hidden styles
    clip: auto;
    clip-path: none;
    overflow: visible;
    padding: var(--spacing-8) var(--spacing-16);
    position: fixed;
    top: 0px;

    // Presentation style
    transition: top var(--animation-speed-fast) ease-in;
    white-space: normal;
    width: 100%;
    z-index: var(--z-index-modal);
  }
}
</style>
